export const unsupportedItemsNoticeStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '12px',
  borderRadius: '6px',
  border: '1px dashed',
  borderColor: 'divider',
  backgroundColor: 'action.hover',
};

export const unsupportedItemsListStyles = {
  margin: 0,
  paddingLeft: '20px',
  listStyle: 'disc',
};

export const unsupportedItemsListItemStyles = {
  margin: 0,
  padding: 0,
};
